export const MIN_NORMAL_SLIPPAGE_TOLERANCE_PERCENT = 2;
export const MAX_NORMAL_SLIPPAGE_TOLERANCE_PERCENT = 11;
